module.exports = __webpack_public_path__ + "img/TrinPodz_File_Sharing_Image_v4.14f0983c.png";